<template>
    <div class="unassigned-task-item">
        <div class="area-description">
            <p class="mb-0"><strong>{{ $t('components.order.basket.basketitem.unassigned_task.missing_product') }}</strong></p>
            <p>{{ task.description['de-CH'] }}</p>
            <template v-if="extractorResultItem">
                <div v-if="extractorResultItem.productIds && extractorResultItem.productIds.length > 0">
                    <strong>{{ $t('components.order.basket.basketitem.unassigned_task.extracted_product_ids') }}:</strong> {{ extractorResultItem.productIds.join(', ') }}
                </div>
                <div v-if="extractorResultItem.productQuery"><strong>{{ $t('components.order.basket.basketitem.unassigned_task.extracted_query') }}:</strong> {{ extractorResultItem.productQuery }}
                </div>
                <div v-if="extractorResultItem.quantity"><strong>{{ $t('components.order.basket.basketitem.unassigned_task.extracted_quantity') }}:</strong> {{ extractorResultItem.quantity }}</div>
            </template>
        </div>

        <div class="area-actions d-flex justify-content-end" v-if="isEditable">
            <b-button-group>
                <b-button :title="$t('components.order.basket.basketitem.unassigned_task.search_button')" @click="openProductSearch" variant="info">
                    <b-icon icon="search"></b-icon> {{ $t('components.order.basket.basketitem.unassigned_task.search_button') }}
                </b-button>
                <b-button v-if="!task.isCompleted" size="sm" variant="success" @click="onTaskSolved" :disabled="isResolving"
                          :title="$t('components.order.basket.basketitem.unassigned_task.resolve_button')">
                    <b-spinner v-if="isResolving" small></b-spinner>
                    <b-icon v-else icon="b-check-circle-fill" /> {{ $t('components.order.basket.basketitem.unassigned_task.resolve_button') }}
                </b-button>
            </b-button-group>
        </div>

        <div v-if="extractorResultItem && extractorResultItem.sourceAttachmentId && extractorResultItem.detectionBoundingBox && extractorResultItem.detectionBoundingBox.length > 0">
            <img class="mw-100" :src="`${baseUrl}/order/api/parseorder/${extractorResultItem.sourceAttachmentId}/orderline/${extractorResultItem.detectionBoundingBox.join(',')}`" />
        </div>
        <div v-else-if="extractorResultItem && extractorResultItem.sourceAttachmentId">
            <image-lightbox :image-url="`${baseUrl}/order/api/parseorder/${extractorResultItem.sourceAttachmentId}/input/withauth/${imageAuthKey}`" :link-only="true"
                            alt="Original Bestellung anschauen" />
        </div>

        <!-- Product Search Modal -->
        <product-search-modal :modal-id="productSearchModal.id" :show.sync="productSearchModal.show" header-bg-variant="info" :initial-product-type="'Product'"
                              :modal-title="$t('components.order.basket.basketitem.unassigned_task.search_modal_title')" :search-label="$t('components.order.basket.basketitem.search_products')"
                              :search-placeholder="$t('components.order.basket.basketitem.search_placeholder')" :results-label="$t('components.order.basket.basketitem.search_results')"
                              :loading-text="$t('components.order.basket.basketitem.searching_products')" :no-results-text="$t('components.order.basket.basketitem.no_products_found')"
                              :initial-state-text="$t('components.order.basket.basketitem.start_searching')"
                              :select-button-text="$t('components.order.basket.basketitem.unassigned_task.search_modal_select_button')"
                              :close-button-text="$t('components.order.basket.basketitem.close_search')" :extract-result="extractorResultItem"
                              :original-request-label="$t('components.order.basket.basketitem.original_request')"
                              :product-query-label="$t('components.order.basket.basketitem.product_query')" @product-selected="selectProduct" />
    </div>
</template>

<script>
import { instances } from '@/$plugins/http';
import ImageLightbox from '@/components/order/orderly/ImageLightbox';
import ProductSearchModal from './ProductSearchModal.vue';

export default {
    name: 'UnassignedTaskItem',
    components: {
        ProductSearchModal,
        ImageLightbox
    },
    props: {
        task: {
            type: Object,
            required: true
        },
        extractorResultItem: {
            type: Object,
            required: true
        },
        order: {
            type: Object,
            required: false
        },
        imageAuthKey: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            isResolving: false,
            productSearchModal: {
                id: `${this.$options.name}_ProductSearchModal`,
                show: false
            },
            editableOrderStates: ['Open', 'Executed', 'Ordered', 'Processing'],
            baseUrl: instances.servicePlatform.defaults.baseURL
        }
    },
    computed: {
        isEditable() {
            return this.order && this.editableOrderStates.includes(this.order.orderState)
        }
    },
    methods: {
        onTaskSolved() {
            this.isResolving = true
            this.$store.dispatch('orderlytasks/resolveTask', { taskId: this.task.id })
                .then(() => {
                    this.$emit('task-resolved', this.task.id)
                    this.isResolving = false
                })
        },
        openProductSearch() {
            this.productSearchModal.show = true
        },
        selectProduct(product, productType) {
            this.$emit('product-selected', this.task, product, productType)
        }
    }
}
</script>

<style lang="scss" scoped>
.unassigned-task-item {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 1rem;
    padding: 1rem;
    background-color: #fffbf0;
    border: 1px solid #ffeaa7;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    position: relative;

    .area-separator {
        grid-column: 1 / -1;
        height: 1px;
        background-color: #ffeaa7;
        margin: 0.5rem 0;
    }

    .area-description {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .item-name {
            font-weight: 600;
            text-transform: uppercase;
        }

        .item-id {
            font-weight: 600;
            text-transform: uppercase;
        }
    }

    .area-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
    }
}
</style>
